import React from "react";
import { View, StyleSheet, Text, Platform } from "react-native";

import Dialog from "../common/dialog";
import ManaButton from "../common/ManaButton";
import ElementItem from "./list/ElementItem";
import AppTheme from "../AppTheme";

export default function MergeElementConfirmDialog({
  from,
  to,
  controller,
  close = () => {},
  mergeElement = () => {},
}) {
  return (
    <Dialog.Container
      onClose={close}
      showCloseButton
      style={styles.container}
      headerStyle={{ margin: 0 }}
      contentStyle={{
        paddingTop: 0,
        marginTop: 0,
        paddingBottom: 16,
        paddingHorizontal: 14,
      }}
    >
      <View style={styles.header}>
        <Text style={styles.title}>Are you sure?</Text>
        <Text style={styles.description}>
          Merging an Element into another Element means that{" "}
          <Text style={{ fontWeight: "600" }}>
            all tracked timeslots, reflection history, journal entries, and
            goals using the Element:
          </Text>
        </Text>
      </View>

      <View style={styles.items}>
        <ElementItem
          item={from}
          controller={controller}
          noIcons
          hideActions
          style={{ paddingHorizontal: 0 }}
        />
        <Text style={styles.replaceText}>will be replaced by the Element:</Text>
        <ElementItem
          item={to}
          controller={controller}
          hideActions
          noIcons
          style={{ paddingHorizontal: 0 }}
        />
      </View>

      <View style={styles.buttons}>
        <ManaButton
          style={[styles.button]}
          styleText={styles.buttonText}
          text="Back"
          onPress={close}
        />

        <ManaButton
          isMainButton
          style={[styles.button]}
          styleText={styles.buttonText}
          text="Merge"
          onPress={mergeElement}
        />
      </View>
    </Dialog.Container>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
  },
  close: {
    position: "absolute",
    top: 5,
    right: 5,
  },
  header: {},
  title: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
    marginTop: 10,
    textAlign: "center",
  },
  description: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    textAlign: "center",
  },
  replaceText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    marginVertical: 12,
  },
  items: {
    marginTop: 16,
  },
  buttons: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    width: 300,
    marginTop: 27,
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 143,
    height: 40,
    borderRadius: 6,
  },
  buttonText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
  },
});
